const SuccessPage = () => {
	return (
		<div>
			<h5>
				Thanks for your feedback.
				<br />
				<br /> Your issue has been logged and we will be in touch ASAP.
			</h5>
		</div>
	);
};

export default SuccessPage;
